module.exports = __webpack_public_path__ + "static/media/iStock-536659322.8a25e513.jpg";